import { render, staticRenderFns } from "./BookingListView.vue?vue&type=template&id=2f62f84c&scoped=true&"
import script from "./BookingListView.vue?vue&type=script&lang=js&"
export * from "./BookingListView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f62f84c",
  null
  
)

export default component.exports